export default function ResultSettingsTemplate(data) {
    //language=HTML
    return `
        <div id="example" role="application">
            <div id="resultSettings" class="demo-section k-content">
                <div id="resultSettingsContainer">
                    <div class="row">
                        <label class="col-md-6" for="displayedColumns" style="padding-top: 2px">${data.translateId("displayedColumns")}</label>
                        <label class="col-md-6" for="notDisplayedColumns" style="padding-top: 2px">${data.translateId("hiddenColumns")}</label>
                    </div>
                    <div class="row">
                        <select class="col-md-6" id="displayedColumns"></select>
                        <select class="col-md-6" id="notDisplayedColumns"></select>
                    </div>
                </div>
            </div>
        </div>`;
}